var exports = {
  "Qs": "x52a3aa3b--5b1deb--content",
  "o1": "x52a3aa3b--5b1deb--actions",
};

module.exports = exports;
